import {
    createStore,
    combineReducers,
    applyMiddleware,
    compose
} from 'redux';
import thunk from 'redux-thunk';
import authReducer from '../reducers/auth';
import vehicleFiltersReducer from '../reducers/vehicleFilters';
import vehicleConfigsReducer from '../reducers/vehicleConfigs';
import vehicleAdsReducer from '../reducers/vehicleAds';
import jobFiltersReducer from '../reducers/jobFilters';
import jobConfigsReducer from '../reducers/jobConfigs';
import jobAdsReducer from '../reducers/jobAds';
import agencyFiltersReducer from '../reducers/agencyFilters';
import agencyDetailFiltersReducer from '../reducers/agencyDetailFilters';
import alarmDetailFiltersReducer from '../reducers/alarmDetailFilters';
import alarmDetailInfoReducer from '../reducers/alarmDetailInfo';
import agencyDetailInfoReducer from '../reducers/agencyDetailInfo';
import agencyConfigsReducer from '../reducers/agencyConfigs';
import agencyAdsReducer from '../reducers/agencyAds';
import galleryFiltersReducer from '../reducers/galleryFilters';
import galleryConfigsReducer from '../reducers/galleryConfigs';
import galleryAdsReducer from '../reducers/galleryAds';
import galleryDetailFiltersReducer from '../reducers/galleryDetailFilters';
import galleryDetailInfoReducer from '../reducers/galleryDetailInfo';
import crossAppConfigReducer from '../reducers/crossAppConfig';
import dashboardReducer from '../reducers/dashboard';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
    const store = createStore(
        combineReducers({
            auth: authReducer,
            vehicleFilters: vehicleFiltersReducer,
            vehicleConfigs: vehicleConfigsReducer,
            vehicleAds: vehicleAdsReducer,
            jobFilters: jobFiltersReducer,
            jobConfigs: jobConfigsReducer,
            jobAds: jobAdsReducer,
            agencyAds: agencyAdsReducer,
            agencyConfigs: agencyConfigsReducer,
            agencyFilters: agencyFiltersReducer,
            agencyDetailFilters: agencyDetailFiltersReducer,
            agencyDetailInfo: agencyDetailInfoReducer,
            alarmDetailFilters: alarmDetailFiltersReducer,
            alarmDetailInfo: alarmDetailInfoReducer,
            galleryAds: galleryAdsReducer,
            galleryConfigs: galleryConfigsReducer,
            galleryFilters: galleryFiltersReducer,
            galleryDetailFilters: galleryDetailFiltersReducer,
            galleryDetailInfo: galleryDetailInfoReducer,
            crossAppConfig: crossAppConfigReducer,
            dashboard: dashboardReducer
        }),
        composeEnhancers(applyMiddleware(thunk))
    );

    return store;
}